<template>
  <div>
    <div class="settings-row">
      <div class="settings-row__name">
        <div class="settings-row__name__title">
          {{ $t(`metrics.${sensor.name.replace(/\s+/g, '_').toLowerCase()}`) }}
        </div>
        <div class="settings-row__name__description">{{ sensor.description }}</div>
      </div>
      <div class="settings-row__actions">
        <div>
          <Sensor :sensor="sensor"  @onChange="changed"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sensor from '@/components/Sensor.vue';

export default {
  name: 'DetailSettingsRow',
  components: {
    Sensor,
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
  },
  methods: {
    changed(data) {
      this.$store.dispatch('tentacle/updateSensor', data);
      // flash a error handler
    },
  },
};
</script>

<style lang="scss">
.settings-row {
  display: flex;
  align-items: center;
  min-height: 6rem;
  border-bottom: 1px solid $border-color;
  padding: 0 3rem;

  &__name {
    line-height: 1.6rem;
    &__title {
      color: $dark;
      font-size: 1.3rem;
      font-weight: 700;
    }

    &__description {
      color: $grey;
    }
  }

  &__actions {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    margin-left: auto;

    button {
        width: 150px;
        color: #f7f7f7;
        margin-left: auto;
        margin-top: 0.5rem;
      background-color: $company-color;
      border: none;
        border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2.8rem;
      cursor: pointer;
      transition: all 0.4s;

      &:hover {
        background-color: darken($company-color, 10%);
      }

      .icon {
        fill: $white;
        width: 1.6rem;
        height: 1.6rem;
      }
    }
  }
}
</style>
